import axios from "axios";
import appConfig from "configs/app.config"; // Action pour déconnexion
import store from "../store"; // Importe le store Redux
import { onSignInSuccess, onSignOutSuccess } from "../store/auth/sessionSlice";
import { setUser } from "../store/auth/userSlice";
const { apiPrefix } = appConfig;

let isRefreshing = false;
let failedQueue = [];

const processQueue = (error, token = null) => {
  failedQueue.forEach((prom) => {
    if (error) {
      prom.reject(error);
    } else {
      prom.resolve(token);
    }
  });
  failedQueue = [];
};

const API = axios.create({
  baseURL: apiPrefix, // Base URL de ton API
  withCredentials: true, // Important pour les cookies HTTP-only
});

// Intercepteur pour ajouter l'accessToken dans les headers
API.interceptors.request.use((config) => {
  const token = store.getState().auth.session.token; // Récupère l'accessToken du store
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Intercepteur pour gérer l'expiration des tokens
API.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    // log
    console.error("error", error);

    if (error.response?.status === 403) {
      // return default view
      window.location.href = "/forbidden"; // Customize the redirect
      return Promise.reject(error);
    }

    // case 400 / 404 / 500, try to intercept the error and message or status
    /*    if (error.response?.status === 400 || error.response?.status === 404 || error.response?.status === 500) {

      // error message can be in status or message or msg
      let errorMessage = error.response.data.message || error.response.data.msg || error.response.data.status;

      alert(errorMessage);

      return Promise.reject(error);
    }*/

    if (error.response?.status === 401 && !originalRequest._retry) {
      if (isRefreshing) {
        return new Promise((resolve, reject) => {
          failedQueue.push({ resolve, reject });
        })
          .then((token) => {
            originalRequest.headers.Authorization = `Bearer ${token}`;
            return API(originalRequest);
          })
          .catch((err) => Promise.reject(err));
      }

      originalRequest._retry = true;
      isRefreshing = true;

      return new Promise((resolve, reject) => {
        const APINew = axios.create({
          baseURL: apiPrefix,
          withCredentials: true,
        });

        APINew.post("/token/refresh")
          .then(async (refreshResponse) => {
            const { token } = refreshResponse.data;
            store.dispatch(onSignInSuccess(refreshResponse.data));

            // Agency filtering is now done in ModernLayout component

            originalRequest.headers.Authorization = `Bearer ${token}`;
            processQueue(null, token);
            resolve(API(originalRequest));
          })
          .catch((refreshError) => {
            processQueue(refreshError, null);
            store.dispatch(onSignOutSuccess());
            reject(refreshError);
          })
          .finally(() => {
            isRefreshing = false;
          });
      });
    }

    return Promise.reject(error);
  },
);

export default API;
